"use client";

import { ArrowRight } from "lucide-react";

const faqs = [
  {
    question: "Quanto tempo serve per migrare da Excel/altro gestionale?",
    answer:
      "La maggior parte dei nostri utenti è operativa in 24-48 ore. Se hai i dati in Excel, li importiamo automaticamente. Se hai un gestionale precedente, estraiamo i dati e facciamo il mapping. E se non sai come fare, lo facciamo noi per te — incluso nel setup.",
  },
  {
    question: "Funziona offline? (agenti sul campo)",
    answer:
      "Sì, al 100%. KennyDB funziona in negozio, al salone, in treno — anche senza connessione. Tutti i dati sono disponibili offline e si sincronizzano automaticamente appena torni online. Nessuna interruzione del lavoro.",
  },
  {
    question: "Posso importare i miei dati da solo?",
    answer:
      "Certo! Forniamo template Excel semplici da compilare. Ma se preferisci, il nostro team può occuparsi dell'importazione completa — compresa la deduplicazione e il mapping dei campi — senza costi aggiuntivi.",
  },
  {
    question: "È compatibile con smartphone e tablet?",
    answer:
      "Assolutamente sì. KennyDB è progettato mobile-first: funziona perfettamente su iPhone, iPad e dispositivi Android. L'interfaccia si adatta automaticamente allo schermo e supporta touch, gesture e fotocamera per lo scanning.",
  },
  {
    question: "Quanto costa dopo i 14 giorni di prova?",
    answer:
      "I piani partono da €12/mese per il piano Base. Il piano Pro a €29/mese include tutte le funzionalità AI, OCR illimitato e supporto prioritario. Per le agenzie con più agenti, abbiamo piani personalizzati. Nessun costo nascosto.",
  },
  {
    question: "Posso esportare i miei dati se voglio cambiare?",
    answer:
      "Sì, i tuoi dati sono sempre tuoi. Puoi esportare tutto in Excel, CSV o JSON in qualsiasi momento, anche durante la prova gratuita. Nessun vendor lock-in, nessuna sorpresa.",
  },
  {
    question: "È adatto anche per agenzie con più agenti?",
    answer:
      "Sì, abbiamo un piano Agenzia che include: dashboard centralizzata per il management, onboarding rapido per nuovi agenti, reportistica consolidata e controllo delle autorizzazioni. Contattaci per una demo personalizzata.",
  },
  {
    question: "I miei brand hanno portali diversi. Come si integra?",
    answer:
      "KennyDB non sostituisce i portali — li affianca. Importi i documenti che già ricevi (ordini, fatture, estratti provvigioni) e il sistema li unifica in un unico posto. I dati escono dai portali e diventano finalmente tuoi.",
  },
];

export function FAQ() {
  return (
    <section className="py-20 md:py-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-honey-50">
      <div className="container mx-auto max-w-3xl">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-ruby-600 mb-4">
            FAQ
          </span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-mocha-950 tracking-tight mb-4">
            Domande frequenti
          </h2>
          <p className="text-lg text-mocha-600 max-w-2xl mx-auto">
            Tutto quello che devi sapere prima di iniziare.
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-white rounded-xl border border-ruby-100 cursor-pointer hover:border-ruby-200 transition-all open:ring-2 open:ring-ruby-100"
            >
              <summary className="flex items-center justify-between p-6 font-sans font-semibold text-mocha-950 list-none cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-ruby-600 focus-visible:ring-inset rounded-xl">
                <span className="pr-4">{faq.question}</span>
                <ArrowRight
                  className="w-5 h-5 transition-transform group-open:rotate-90 text-ruby-600 shrink-0"
                  aria-hidden="true"
                />
              </summary>
              <div className="text-mocha-600 leading-relaxed px-6 pb-6">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>

        {/* Additional help text */}
        <div className="mt-12 text-center">
          <p className="text-mocha-600 mb-4">Hai altre domande?</p>
          <a
            href="https://wa.me/390000000000"
            className="inline-flex items-center text-ruby-600 font-semibold hover:underline"
          >
            Scrivici su WhatsApp
            <ArrowRight className="ml-1 h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
